<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 基本信息 </a-col>
      </a-row>
      <a-form-model
        :model="data"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="门店名称">
              <a-input v-model="data.shopName" placeholder="请输入门店名称">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="联系电话">
              <a-input v-model="data.shopPhone" placeholder="请输入联系电话">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="负责人姓名">
              <a-input v-model="data.dutyName" placeholder="请输入负责人姓名">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="负责人电话">
              <a-input v-model="data.dutyPhone" placeholder="请输入负责人电话">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="门店分类">
              <a-select
                v-model="data.categoryId"
                placeholder="请选择"
                style="width: 100%"
                @change="storeType"
              >
                <a-select-option
                  v-for="(item, index) in xiala"
                  :key="index"
                  :value="item.objId"
                >
                  {{ item.categoryName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="营业时间">
              <a-time-picker format="HH:mm:ss" @change="onChange1" /> -
              <a-time-picker format="HH:mm:ss" @change="onChange2" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="门店编号">
              <a-input v-model="data.shopNo" placeholder="请输入门店编号">
              </a-input>
            </a-form-model-item>
          </a-col>
<!--          <a-col :span="11" v-if="role === '0'">-->
          <a-col :span="11">
            <a-form-model-item label="商家">
              <a-select
                v-model="data.merchantsId"
                placeholder="请选择"
                style="width: 100%"
                @change="storeType"
              >
                <a-select-option
                  v-for="(item, index) in merchantsSelect"
                  :key="index"
                  :value="item.objId"
                >
                  {{ item.merchantsName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
<!--          <a-col :span="11" :offset="2" v-if="role === '0'">-->
          <a-col :span="11" :offset="2">
            <a-form-model-item label="有效期">
              <a-date-picker style="width: 100%"  v-model:value="data.validDate" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="24">
            <a-form-model-item
              label="门店简介"
              :labelCol="textarealabelCol"
              :wrapperCol="textareaWrapperCol"
            >
              <a-textarea
                v-model="data.introduce"
                placeholder="请输入"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="上传负责人证件">
              <a-row>
                <a-col :span="12">
                  <a-upload
                    :customRequest="uploadone"
                    list-type="picture-card"
                    :file-list="idcardFront"
                    @preview="handlePreview"
                    @change="IDCardFront"
                  >
                    <div v-if="idcardFront.length < 1">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">Upload</div>
                    </div>
                  </a-upload>
                  <a-modal
                    :visible="previewVisible"
                    :footer="null"
                    @cancel="handleCancel"
                  >
                    <img
                      alt="example"
                      style="width: 100%"
                      :src="IDCardFrontImage"
                    />
                  </a-modal>
                </a-col>
                <a-col :span="12">
                  <a-upload
                    :customRequest="uploadtwo"
                    list-type="picture-card"
                    :file-list="idcardBack"
                    @preview="handlePreview"
                    @change="IDCardBcak"
                  >
                    <div v-if="idcardBack.length < 1">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">Upload</div>
                    </div>
                  </a-upload>
                  <a-modal
                    :visible="previewVisible"
                    :footer="null"
                    @cancel="handleCancel"
                  >
                    <img
                      alt="example"
                      style="width: 100%"
                      :src="IDCardBackImage"
                    />
                  </a-modal>
                </a-col>
              </a-row>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              label="门店详情"
              :labelCol="textarealabelCol"
              :wrapperCol="textareaWrapperCol"
            >
              <quill-editor
                v-model="data.details"
                ref="myQuillEditor"
                :options="editorOption"
                @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)"
                @change="onEditorChange($event)"
              >
              </quill-editor>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <!-- 营业执照信息 -->
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 营业执照信息 </a-col>
      </a-row>
      <a-form-model
        :model="data"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="执照名称">
              <a-input v-model="data.licenseName" placeholder="请输入执照名称">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="执照注册号">
              <a-input
                v-model="data.licenseNo"
                placeholder="请输入社会统一代码"
              >
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="上传营业执照">
              <a-row>
                <a-col :span="12">
                  <a-upload
                    :file-list="licenseImgList"
                    list-type="picture-card"
                    :customRequest="uploadthree"
                    @preview="handlePreview"
                    @change="handlList"
                  >
                    <div v-if="licenseImgList.length < 1">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">Upload</div>
                    </div>
                  </a-upload>
                  <a-modal
                    :visible="previewVisible"
                    :footer="null"
                    @cancel="handleCancel"
                  >
                    <img alt="example" style="width: 100%" :src="imageUrl" />
                  </a-modal>
                </a-col>
              </a-row>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2"> </a-col>
        </a-row>
      </a-form-model>
    </div>
    <!-- 地址信息 -->
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 地址信息 </a-col>
      </a-row>
      <!-- layout="" -->
      <a-form-model
        :model="data"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="归属地">
              <a-input v-model="details" placeholder="请输入归属地"> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="详细地址">
              <a-input v-model="data.address" placeholder="请输入详细地址">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="地址搜索">
              <a-input
                v-model="data.address"
                placeholder="请输入商户地址，或附近地标"
              >
              </a-input>
              <!-- <span class="illustrate">1.参考地图定位，如果商家坐标不符，请纠正定位信息</span>
              <span class="illustrate">2.使用地址辅助搜索可快速定位商户所属地，点击地图获取商户精确坐标</span> -->
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2"> </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="地图信息">
              <div class="amap-page-container">
                <div
                  id="mapChart"
                  :style="{ width: '70vh', height: '70vh' }"
                ></div>

                <div class="toolbar">
                  <span v-if="loaded">
                    location: lng = {{ lng }} lat = {{ lat }}
                  </span>
                  <span v-else>正在定位</span>
                </div>
                <div v-on:click="req_post()">查询周边</div>
              </div>

              <span class="illustrate"
                >1.参考地图定位，如果商家坐标不符，请纠正定位信息</span
              >
              <span class="illustrate"
                >2.使用地址辅助搜索可快速定位商户所属地，点击地图获取商户精确坐标</span
              >
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2"> </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label=" ">
              <span class="illustrate"
                >1.参考地图定位，如果商家坐标不符，请纠正定位信息</span
              >
              <span class="illustrate"
                >2.使用地址辅助搜索可快速定位商户所属地，点击地图获取商户精确坐标</span
              >
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2"> </a-col>
        </a-row>
      </a-form-model>
    </div>
    <div class="but">
      <a-button @click="preservation">保存</a-button>
      <a-button @click="goBack">返回</a-button>
    </div>
  </div>
</template>
<script>
import editUpload from "./editUpload.vue";
import { storeListEditXiala, getstoresDataEdit, merchantsListSelect } from "@/api/homeApi.js";
import { picUpload } from "@/api/storeApi.js";
import { modifyEdit } from "@/api/hometwoApi.js";
import { message } from "ant-design-vue";
export default {
  components: { editUpload },
  data() {
    return {
      uid: null,
      details: "",
      data: {
        introduce: "1",
        shopName: "", //门店名称
        dutyCardFront: "", //身份证正面
        dutyCardReverse: "", //身份证反面
        licenseName: "", //营业执照名称
        shopPhone: "", //联系电话
        dutyName: "", //负责人姓名
        dutyPhone: "", //负责人电话
        address: "", //详细地址
        licenseImg: "", //营业执照
        licenseNo: "",
        categoryName: "",
        details: "1", // 门店详情
        longitude: "112",
        latitude: "31",
        regionRecord: "{}",
        shopNo: "",
        merchantsId: "",// 商家id
        cityId: "3",
        areaId: "100000",
        categoryId: "",
        objId: "",
        endRunTime: "",
        startRunTime: "",
        validDate: ""
      },
      IDCardFrontImage: "",
      IDCardBackImage: "",
      previewVisible: false,
      imageUrl: "",
      IDCardFrontImage: "",
      IDCardBackImage: "",
      imageUrl: "",
      licenseImgList: [],
      idcardFront: [],
      idcardBack: [],
      xiala: [],
      merchantsSelect: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      textarealabelCol: { span: 2 },
      textareaWrapperCol: { span: 21, offset: 1 },
      role: sessionStorage.getItem("role"),
    };
  },
  mounted() {
    this.uid = this.$route.query.uid;
    this.getlistInfo();
    this.getStoreListEditXiala();
    this.getMerchantsListSelect();
    this.initmapFn();
  },

  methods: {
    getStoreListEditXiala() {
      storeListEditXiala({ limit: 10, page: 1 }).then((res) => {
        this.xiala = res.data;
      });
    },
    getMerchantsListSelect() {
      merchantsListSelect().then(res =>{
        this.merchantsSelect = res.data;
      });
    },
    initmapFn() {
      console.log("11111111111111111");
      var _this = this;
      // 创建地图，同时给地图设置中心点、级别、显示模式、自定义样式等属性
      _this.map1 = new AMap.Map("mapChart", {
        resizeEnable: true, //是否监控地图容器尺寸变化
        zoom: 12, // 缩放级别
        center: [113.985868, 22.523237], //中心点坐标
      });
      //插件依旧写在回调函数内,通过AMap.plugin方法按需引入插件，第一个参数是插件名,第二个是在plugin回调之后使用插件功能。
      _this.map1.plugin(["AMap.Geocoder"], function () {
        //点击地图得到经纬度
        _this.map1.on("click", function (ev) {
          _this.getAddress([ev.lnglat.lng, ev.lnglat.lat]);
          //  _this.onMarkerMap([ev.lnglat.lat, ev.lnglat.lng]);高德key在哪里
        });
      });
    },
    // 经纬度转化为详细地址 注释了就没有地图了》刷新就不显是地图
    getAddress(e) {
      let that = this;
      AMap.plugin("AMap.Geocoder", function () {
        let geocoder = new AMap.Geocoder({
          radius: 100,
          extensions: "all",
        });

        geocoder.getAddress(e, function (status, result) {
          console.log("dddddddddddddddd", e);
          if (status === "complete" && result.info === "OK") {
            let address = result.regeocode.formattedAddress;
            console.log(result.regeocode);
            that.data.address = result.regeocode.formattedAddress;
            let a = result.regeocode.formattedAddress.slice(3, 9);
            that.details = a;
            // that.placeSearch(that.address)
          }
        });
      });
    },
    //搜索地址
    searchAddress() {
      let that = this;
      AMap.plugin("AMap.PlaceSearch", function () {
        var placeSearch = new AMap.PlaceSearch({
          // city 指定搜索所在城市，支持传入格式有：城市名、citycode和adcode
          city: "全国",
        });
        placeSearch.search(that.data.address, function (status, result) {
          // 查询成功时，result即对应匹配的POI信息
          console.log("dddddddddddddddd", result.poiList.pois[0].location);
          that.onMarkerMap(
            result.poiList.pois[0].location.Q,
            result.poiList.pois[0].location.R
          );
          //console.log('dddddddddddddddd', that.data.address)
        });
      });
    },
    onMarkerMap(Q, R) {
      let marker = new AMap.Marker({
        //在回调函数里面创建Marker实例,添加经纬度和标题
        position: [Q, R], //添加经纬度
        offset: new AMap.Pixel(-13, -30), // 偏移量
        // title: "广州塔", // 鼠标移上去时显示的内容
        // 可以自定义标记点显示的内容,允许插入html字符串
        // content: "<h1>广州塔Content</h1>",
      });
      this.map1.add(marker); // 将创建的点标记添加到已有的地图实例： 这里吗
    },
    getlistInfo() {
      getstoresDataEdit(1, 1, this.uid).then((res) => {
        this.data = res.data[0];
        const originFileObj = {
          uid: "-1",
          name: "图片",
          status: "done",
          url: res.data[0].dutyCardFront,
          thumbUrl: res.data[0].dutyCardFront,
        };
        this.idcardFront.push(originFileObj);
        const dutyCardReverse = {
          uid: "-1",
          name: "图片",
          status: "done",
          url: res.data[0].dutyCardReverse,
          thumbUrl: res.data[0].dutyCardReverse,
        };
        this.idcardBack.push(dutyCardReverse);
        const licenseImg = {
          uid: "-1",
          name: "图片",
          status: "done",
          url: res.data[0].licenseImg,
          thumbUrl: res.data[0].licenseImg,
        };
        this.licenseImgList.push(licenseImg);
        console.log("this.data", this.data);
      });
    },
    handleSubmit(e) {},
    handleCancel() {},
    cancel() {},
    onChange1(time, startTime) {
      console.log(startTime, "startTime");
      this.data.startRunTime =startTime || "00:00:00";
    },
    onChange2(time, endTime) {
      console.log(endTime, "endTime");
      this.data.endRunTime = endTime || "23:59:59";
    },
    storeType() {},
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handlList({ fileList }) {
      if (fileList == "") {
        this.licenseImgList = [];
      }
    },
    IDCardFront({ fileList }) {
      console.log("front----------", fileList);
      if (fileList == "") {
        this.idcardFront = [];
      }
    },
    IDCardBcak({ fileList }) {
      console.log("front----------", fileList);
      if (fileList == "") {
        this.idcardBack = [];
      }
    },
    goBack() {
      this.$router.push(`/home/storeManagement/managementHom`);
    },
    //身份证正面
    uploadone(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error("请确保图片大小在2M以内");
        return false;
      }
      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);
      picUpload(form)
        .then((res) => {
          this.data.dutyCardFront = res.data;
          const originFileObj = {
            uid: "-1",
            name: "图片",
            status: "done",
            url: res.data,
            thumbUrl: res.data,
          };
          this.idcardFront.push(originFileObj);
          console.log("one", this.idcardFront);
          message.success("上传成功");
        })
        .catch((err) => {
          message.error("请确保图片大小在2M以内");
        });
    },
    //身份证反面
    uploadtwo(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error("请确保图片大小在2M以内");
        return false;
      }
      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);
      picUpload(form)
        .then((res) => {
          this.data.dutyCardReverse = res.data;
          const originFileObj = {
            uid: "-1",
            name: "图片",
            status: "done",
            url: res.data,
            thumbUrl: res.data,
          };
          this.idcardBack.push(originFileObj);
          console.log("two", this.data.dutyCardReverse);
        })
        .catch((err) => {
          message.error("请确保图片大小在2M以内");
        });
    },
    //营业执照
    uploadthree(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error("请确保图片大小在2M以内");
        return false;
      }
      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);
      picUpload(form)
        .then((res) => {
          this.data.licenseImg = res.data;
          const originFileObj = {
            uid: "-1",
            name: "图片",
            status: "done",
            url: res.data,
            thumbUrl: res.data,
          };
          this.licenseImgList.push(originFileObj);
          console.log("two", this.licenseImgList);
        })
        .catch((err) => {
          message.error("请确保图片大小在2M以内");
        });
    },
    // 保存编辑
    preservation() {
      // let data = this.data
      modifyEdit({
        shopName: this.data.shopName,
        dutyCardFront: this.data.dutyCardFront,
        dutyCardReverse: this.data.dutyCardReverse,
        licenseName: this.data.licenseName,
        dutyName: this.data.dutyName,
        dutyPhone: this.data.dutyPhone,
        licenseImg: this.data.licenseImg,
        categoryName: this.data.categoryName,
        longitude: this.data.longitude,
        latitude: this.data.latitude,
        shopId: this.data.shopId,
        details: this.data.details,
        cityId: "3",
        areaId: this.data.areaId,
        categoryId: this.data.categoryId,
        address: this.data.address,
        introduce: this.data.introduce,
        logo: this.data.logo,
        uid: this.data.uid,
        shopPhone: this.data.shopPhone,
        endRunTime: this.data.endRunTime,
        startRunTime: this.data.startRunTime,
        merchantsId: this.data.merchantsId,
        validDate: this.data.validDate
      }).then((res) => {
        if (res.code === "9999") {
          message.warning("缺少编辑信息");
        } else {
          message.success(res.info);
          this.$router.push(`/home/storeManagement/managementHom`);
        }
        // this.data = res;
        // console.log("this.data", this.data);
      });
    },
  },
};
</script>

<style lang="scss" scoped="" type="text/css">
.illustrate {
  color: red;
}
.but {
  margin-left: 4%;
  margin-bottom: 20px;
  button {
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/storeManagement/storeManagement/edit/edit.vue